import firebase from '@firebase/app'
import '@firebase/auth'
import '@firebase/database'

const state = {
  user: null,
  userRoute: ''
}

const getters = {
  user (state) {
    return state.user
  },
  userRoute (state) {
    return state.userRoute
  }
}

const mutations = {
  setUser (state, payload) {
    state.user = payload
  },
  resetPopup (state) {
    state.popup.show = false
  },
  setPopup (state, payload) {
    state.popup = payload
  },
  setUserRoute (state, payload) {
    state.userRoute = payload
  }
}

const actions = {
  setUser (store, payload) {
    store.commit('setUser', payload)
  },
  setUserRoute (store, payload) {
    store.commit('setUserRoute', payload)
  },
  updateLastSeen (store, payload) {
    firebase.database().ref('users/' + payload + '/lastSeen').set(firebase.database.ServerValue.TIMESTAMP)
  },
  signIn: (store, payload) => new Promise((resolve, reject) => {
    firebase.auth().signInWithEmailAndPassword(payload.email, payload.password).then(userSnap => {
      firebase.database().ref('users/' + userSnap.user.uid).once('value').then(snapshot => {
        store.commit('setUser', {uid: snapshot.key, ...snapshot.val()})
        firebase.database().ref('users/' + userSnap.user.uid + '/lastLogin').set(firebase.database.ServerValue.TIMESTAMP)
        store.dispatch('loadProgress').then(() => {
          resolve()
        })
      })
    }).catch(err => {
      reject(err)
    })
  }),
  signOut: (store) => new Promise((resolve, reject) => {
    firebase.auth().signOut().then(() => {
      store.commit('setUser', null)
      store.dispatch('resetQuestions')
      store.dispatch('resetUsersModule')
      store.dispatch('resetProgressModule')
      resolve()
    }).catch((err) => {
      reject(err)
    })
  }),
  signUp: (store, payload) => new Promise((resolve, reject) => {
    const newUser = {
      ...payload,
      password: null,
      pass2: null,
      dateCreated: firebase.database.ServerValue.TIMESTAMP,
      lastLogin: firebase.database.ServerValue.TIMESTAMP
    }
    firebase.auth().createUserWithEmailAndPassword(payload.email, payload.password).then(userSnap => {
      firebase.database().ref('users/' + userSnap.user.uid).set(newUser)
      store.commit('setUser', {uid: userSnap.user.uid, ...newUser})
      store.dispatch('loadProgress').then(() => {
        resolve()
      })
    }).catch(err => {
      reject(err)
    })
  }),
  passwordReset: (store, payload) => new Promise((resolve, reject) => {
    firebase.auth().sendPasswordResetEmail(payload).then(() => {
      resolve()
    }).catch((err) => {
      reject(err)
    })
  })
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js